import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style/TagInput.module.css';
import DOMPurify from 'dompurify';

const MAX_TAGS = 5;

export default function TagInput({ tags, setTags, placeholder }) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const addTag = (value) => {
    const sanitizedValue = DOMPurify.sanitize(value, { USE_PROFILES: { html: false } });
    const v = sanitizedValue.trim();

    if (v && !tags.includes(v) && tags.length < MAX_TAGS) {
      setTags([...tags, v]);
    }
    setInputValue('');
  };

  const removeTag = (idx) => {
    setTags(tags.filter((_, i) => i !== idx));
  };

  const handleKeyDown = (e) => {
    if (e.nativeEvent.isComposing) {
      return;
    }

    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      if (tags.length < MAX_TAGS) {
        addTag(inputValue);
      }
    } else if (e.key === 'Backspace' && !inputValue) {
      removeTag(tags.length - 1);
    }
  };

  const inputPlaceholder = tags.length >= MAX_TAGS 
    ? t('tagInput.maxTagsPlaceholder', { count: MAX_TAGS }) 
    : placeholder;
  
  return (
   <div className={styles.tagInputWrapper} onClick={() => inputRef.current.focus()}>
        <input
            ref={inputRef}
            className={styles.tagInput}
            value={inputValue}
            placeholder={inputPlaceholder}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={tags.length >= MAX_TAGS}
        />
        <div className={styles.tagsContainer}>
            {tags.map((tag, idx) => (
            <span className={styles.tagChip} key={idx}>
                {tag}
                <button 
                  type="button" 
                  onClick={() => removeTag(idx)} 
                  title={t('tagInput.removeTagButton')}
                >
                  ×
                </button>
            </span>
            ))}
        </div>
    </div>
  );
}